import { AnyAction } from 'redux';

export const INIT = 'app/OrganizationDetailsPage/INIT';
export const INIT_SUCCESS = 'app/OrganizationDetailsPage/INIT_SUCCESS';
export const INIT_FAILED = 'app/OrganizationDetailsPage/INIT_FAILED';

export const SET_FETCH_PARAMS = 'app/OrganizationDetailsPage/SET_FETCH_PARAMS';
export const FETCH_SUCCESS = 'app/OrganizationDetailsPage/FETCH_SUCCESS';
export const FETCH_FAILED = 'app/OrganizationDetailsPage/FETCH_FAILED';

export const FETCH_DONATIONS_TOTAL = 'app/OrganizationDetailsPage/FETCH_DONATIONS_TOTAL';
export const FETCH_DONATIONS_TOTAL_SUCCESS =
  'app/OrganizationDetailsPage/FETCH_DONATIONS_TOTAL_SUCCESS';
export const FETCH_DONATIONS_TOTAL_FAILED =
  'app/OrganizationDetailsPage/FETCH_DONATIONS_TOTAL_FAILED';

export const FETCH_VOLUNTEERHOURS_TOTAL = 'app/OrganizationDetailsPage/FETCH_VOLUNTEERHOURS_TOTAL';
export const FETCH_VOLUNTEERHOURS_TOTAL_SUCCESS =
  'app/OrganizationDetailsPage/FETCH_VOLUNTEERHOURS_TOTAL_SUCCESS';
export const FETCH_VOLUNTEERHOURS_TOTAL_FAILED =
  'app/OrganizationDetailsPage/FETCH_VOLUNTEERHOURS_TOTAL_FAILED';

export const FETCH_DEEDS_TOTAL = 'app/OrganizationDetailsPage/FETCH_DEEDS_TOTAL';
export const FETCH_DEEDS_TOTAL_SUCCESS = 'app/OrganizationDetailsPage/FETCH_DEEDS_TOTAL_SUCCESS';
export const FETCH_DEEDS_TOTAL_FAILED = 'app/OrganizationDetailsPage/FETCH_DEEDS_TOTAL_FAILED';

export const FETCH_PARTNERS = 'app/OrganizationDetailsPage/FETCH_PARTNERS';
export const FETCH_PARTNERS_SUCCESS = 'app/OrganizationDetailsPage/FETCH_PARTNERS_SUCCESS';
export const FETCH_PARTNERS_FAILED = 'app/OrganizationDetailsPage/FETCH_PARTNERS_FAILED';

export const CREATE_PARTNER = 'app/OrganizationDetailsPage/CREATE_PARTNER';
export const CREATE_PARTNER_SUCCESS = 'app/OrganizationDetailsPage/CREATE_PARTNER_SUCCESS';
export const CREATE_PARTNER_FAILED = 'app/OrganizationDetailsPage/CREATE_PARTNER_FAILED';

export const DELETE_PARTNER = 'app/OrganizationDetailsPage/DELETE_PARTNER';
export const DELETE_PARTNER_SUCCESS = 'app/OrganizationDetailsPage/DELETE_PARTNER_SUCCESS';
export const DELETE_PARTNER_FAILED = 'app/OrganizationDetailsPage/DELETE_PARTNER_FAILED';

export const init = (params: any): AnyAction => ({
  type: INIT,
  params,
});

export interface Init {
  type: typeof INIT;
}

export const initSuccess = (): AnyAction => ({
  type: INIT_SUCCESS,
});

export const setFetchParamsAction = (params: any): AnyAction => ({
  type: SET_FETCH_PARAMS,
  params,
});

export interface FetchParams {
  type: typeof SET_FETCH_PARAMS;
}

export const initFailed = (error: Error): AnyAction => ({
  type: INIT_FAILED,
  error,
});

export const fetchSuccess = (): AnyAction => ({
  type: FETCH_SUCCESS,
});

export const fetchDonationsTotal = (id: string): AnyAction => ({
  type: FETCH_DONATIONS_TOTAL,
  id,
});

export const fetchDonationsTotalSuccess = (donationsTotal: number): AnyAction => ({
  type: FETCH_DONATIONS_TOTAL_SUCCESS,
  donationsTotal,
});

export const fetchDonationsTotalFailed = (error: Error): AnyAction => ({
  type: FETCH_DONATIONS_TOTAL_FAILED,
  error,
});

export const fetchVolunteerTimesTotal = (id: string): AnyAction => ({
  type: FETCH_VOLUNTEERHOURS_TOTAL,
  id,
});

export const fetchVolunteerTimesTotalSuccess = (volunteerHoursTotal: number): AnyAction => ({
  type: FETCH_VOLUNTEERHOURS_TOTAL_SUCCESS,
  volunteerHoursTotal,
});

export const fetchVolunteerTimesTotalFailed = (error: Error): AnyAction => ({
  type: FETCH_VOLUNTEERHOURS_TOTAL_FAILED,
  error,
});

export const fetchDeedsTotal = (id: string): AnyAction => ({
  type: FETCH_DEEDS_TOTAL,
  id,
});

export const fetchDeedsTotalSuccess = (deedsTotal: number): AnyAction => ({
  type: FETCH_DEEDS_TOTAL_SUCCESS,
  deedsTotal,
});

export const fetchDeedsTotalFailed = (error: Error): AnyAction => ({
  type: FETCH_DEEDS_TOTAL_FAILED,
  error,
});

export const fetchPartnersAction = (
  search?: any,
  countryCode?: any,
  acceptsDonations?: boolean
): AnyAction => ({
  type: FETCH_PARTNERS,
  search,
  countryCode,
  acceptsDonations,
});

export const fetchPartnersSuccessAction = (): AnyAction => ({
  type: FETCH_PARTNERS_SUCCESS,
});

export const fetchPartnersFailedAction = (error: any): AnyAction => ({
  type: FETCH_PARTNERS_FAILED,
  error,
});

export const createPartnerAction = (id: string): AnyAction => ({
  type: CREATE_PARTNER,
  id,
});

export const createPartnerSuccessAction = (): AnyAction => ({
  type: CREATE_PARTNER_SUCCESS,
});

export const createPartnerFailedAction = (error: any): AnyAction => ({
  type: CREATE_PARTNER_FAILED,
  error,
});

export const deletePartnerAction = (partner: string): AnyAction => ({
  type: DELETE_PARTNER,
  partner,
});

export const deletePartnerSuccessAction = (): AnyAction => ({
  type: DELETE_PARTNER_SUCCESS,
});

export const deletePartnerFailedAction = (error: any): AnyAction => ({
  type: DELETE_PARTNER_FAILED,
  error,
});
